import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getXPatterns } from '../../reducers/patterns';
import { getActiveSewpatId } from '../../reducers/sewpats';
import { getPatternsStripeCount } from '../../reducers/ui.patterngallery';
import CategoriesGalleries from '../categories/CategoriesOverviewLanding';
import SelectedValuesPane from '../common/SelectedValuesPane';
import Text from '../common/Text';
import InternalLink from '../InternalLink';
import PatternNewest from '../patterngalleries/NewestPatternGalleryStripe';
import Search from '../SiteSearch';
import Translatable from '../common/Translatable';
import Bottom from '../home/LandingPageBottom';

const CategoriesOverviewLayout = styled.div`
    margin: ${props => props.theme.space[7]} ${props => props.theme.space[8]} ${
    props => props.theme.space[9]} ${props => props.theme.space[10]};
`;

const CategoriesOverview = ({ newPatternsCount, patterns, sewpatId }) => (
    <React.Fragment>
        <SelectedValuesPane sewpatId={sewpatId} />
        <CategoriesOverviewLayout>
            <InternalLink
                to={{
                    type: 'NAVIGATED_TO_NEWEST_PATTERNGALLERY',
                    payload: { sewpatId },
                }}
            >
                {[<Translatable message='NEWEST_FABRIC_LABEL' />, ' >']}
            </InternalLink>

            <PatternNewest
                columns={newPatternsCount} patterns={patterns}
                sewpatId={sewpatId}
            />
            <Text.Divider margin={'1.62em 0 1em'} />
            <Search />
            <Text.Divider margin={'1.31em 0 0'} />
            <CategoriesGalleries />
        </CategoriesOverviewLayout>
        <Text.Divider />
        <Bottom />
    </React.Fragment>
);

const MapStateToProps = (state, ownProps) => {
    const columns = getPatternsStripeCount(state);
    return {
        newPatternsCount: columns,
        patterns: getXPatterns(state, columns),
        sewpatId: getActiveSewpatId(state),
    };
};

const MapDispatchToProps = (dispatch, state) => (
    {}
);

export default connect(MapStateToProps, MapDispatchToProps)(CategoriesOverview);



// WEBPACK FOOTER //
// ./src/components/categories/CategoriesOverview.js